import { render, staticRenderFns } from "./SocketConnect.vue?vue&type=template&id=cfb263b0&"
import script from "./SocketConnect.vue?vue&type=script&lang=js&"
export * from "./SocketConnect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports